import React, { useState } from "react";
import { MDBInput } from 'mdb-react-ui-kit';
import { Title, TitleEditIcon, TitleSaveIcon } from "./BuilderComponents";

export default function CustomHeader({ initialTitle, onTitleChange, isEditingTable }) {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(initialTitle);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    onTitleChange(title); // Pass the updated title back to the parent component
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  return (
      <tr>
        <th style={{background: 'linear-gradient(to left, #6161FF, transparent 200%)'}}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '2rem' }}>
            <div>
              {isEditing ? (<MDBInput type="text" value={title} onChange={handleTitleChange}/>) : (<Title>{title}</Title>)}
            </div>
            <div>
              {isEditing ? (<TitleSaveIcon onClick={handleSaveClick} />) : (isEditingTable ? <TitleEditIcon onClick={handleEditClick} /> : (null))}
            </div>
          </div>
        </th>
      </tr>
  );
}
